import { Model } from 'modules/core/lib/mobx-rest'

export interface IPublicHoliday {
  id: number
  date: string
  summary: string
  country: string
  region: string | null
  city: string | null
}

class PublicHoliday extends Model<IPublicHoliday> {
  static urlRoot() {
    return '/public_holidays'
  }
}

export default PublicHoliday
